import styled from "styled-components";
import * as variables from "../../../css/variables"

export default styled.div`
  .header-text-new {
    @media (min-width: ${variables.Breakpoints.Tablet}) {
      height: 37px;
      font-size: 20px;
    }
    @media (min-width: ${variables.Breakpoints.Laptop}) {
      // width: 150px;
      height: 50px;
      font-size: 20px;
      padding-right: 15px;
      padding-left: 15px;
      font-size: 20px;
    }
    @media (min-width: ${variables.Breakpoints.Wide}) {
      // width: 150px;
      height: 44px;
      font-size: 16px;
      padding-right: 15px;
      padding-left: 15px;
      font-size: 20px;
    }
    // position:relative;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.65;
    letter-spacing: normal;
    border-top-right-radius: 16px;
    border-bottom-left-radius: 16px;
    background-color: ${variables.$marigold};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: IRANSans;
    font-size: 16px;
    font-weight: bold;
    height: 31px;
    padding-right: 10px;
    padding-left: 10px;
    color: rgba(0, 0, 0, 0.87);
    top: -1px;
    right: -1px;
    position: absolute;
    height: 31px;
    width: auto;
  }

  .root {
    z-index: 1;
    position: relative;
    width: 100%;
    // overflow: hidden;
    margin: 20px 0 20px;
    padding: 10px 20px 20px;
    padding-top: 120px;
    object-fit: contain;
    border-radius: 16px;
    // border: solid 2px #e2e2e2;
    backdrop-filter: blur(3px);
    border: 1px solid rgba(226, 226, 226, 0.3);
    background-color: rgba(251, 251, 251, 0.3);
    adow:
      0 4px 8px 0 rgba(0, 0, 0, 0.2),
      0 6px 20px 0 rgba(0, 0, 0, 0.19);
    .title {
      width: 100%;
      height: 20%;
      margin: 0 0 20px;
      background-color: white;
      text-align: center;
      padding: 10px 100px 10px 100px;
      object-fit: contain;
      border-radius: 8px;
      border: solid 3px ${variables.$denim_blue};

      span {
        @media (max-width: 990px) {
          font-size: 16px;
        }
        @media (max-width: 590px) {
          font-size: 14px;
        }
        color: ${variables.$denim_blue};
        font-size: 20px;
        font-weight: bold;
        font-stretch: normal;
      }
    }

    .body {
      @media (max-width: 990px) {
        flex-direction: column;
        width: 100%;
        align-content: space-between;
        height: auto;
      }
      height: 600px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .right {
        @media (max-width: 990px) {
          width: 100%;
          font-size: 14px;
          margin-bottom: 20px;
        }
        @media (max-width: 590px) {
          font-size: 12px;
        }
        width: 32%;
        .items {
          @media (min-width: 990px) {
            min-height: 100% !important;
            overflow-y: scroll;
            ::-webkit-scrollbar {
              width: 8px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
              background-color: rgba(129, 129, 129, 0.1);
              box-shadow: inset 0 0 1px grey;

              border-radius: 8px;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: #41539d;
              border-radius: 8px;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
              background: #546fd7;
            }
          }
          transition: max-height ease 0.7s;
          -moz-transition: max-height 0.7s; /* Firefox 4 */
          -webkit-transition: max-height 0.7s; /* Safari and Chrome */
          -o-transition: max-height 0.7s;
          display: flex;
          flex-direction: column;
          height: fit-content;
          overflow: hidden;
          text-align: center;
          border-radius: 8px;
          background-color: #f5f6fa;
          /* Track */
          ::-webkit-scrollbar-track {
            background-color: rgba(129, 129, 129, 0.1);
            box-shadow: inset 0 0 1px grey;

            border-radius: 8px;
          }

          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #41539d;
            border-radius: 8px;
          }

          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #546fd7;
          }

          .item {
            margin: 10px 0px 20px 0px;
            max-height: fit-content;
            display: flex;
            flex-direction: row;
            text-align: center;
            justify-content: space-around;

            .item-right {
            }
            .item-center {
              font-weight: bolder;
            }
            .item-left {
              color: ${variables.$warm_grey};
            }
          }
        }

        .show-more {
          @media (max-width: 990px) {
            display: block;
          }
          text-align: center;
          display: none;
          position: relative;
          background-image: linear-gradient(
            to bottom,
            rgba(194, 194, 194, 0),
            #a2a2a2
          );
          border-bottom-right-radius: 8px;
          border-bottom-left-radius: 8px;
        }
      }
      .center {
        @media (max-width: 990px) {
          width: 100%;
          font-size: 14px;
          margin-bottom: 20px;
        }
        @media (max-width: 590px) {
          font-size: 12px;
        }
        width: 32%;
        height: inherit;

        .items {
          @media (min-width: 990px) {
            min-height: 100% !important;
            overflow-y: scroll;
            ::-webkit-scrollbar {
              width: 8px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
              background-color: rgba(129, 129, 129, 0.1);
              box-shadow: inset 0 0 1px grey;

              border-radius: 8px;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: #41539d;
              border-radius: 8px;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
              background: #546fd7;
            }
          }
          transition: max-height ease 0.7s;
          -moz-transition: max-height 0.7s; /* Firefox 4 */
          -webkit-transition: max-height 0.7s; /* Safari and Chrome */
          -o-transition: max-height 0.7s;
          display: flex;
          flex-direction: column;
          height: fit-content;
          overflow: hidden;
          text-align: center;
          border-radius: 8px;
          background-color: #f5f6fa;
          /* Track */
          ::-webkit-scrollbar-track {
            background-color: rgba(129, 129, 129, 0.1);
            box-shadow: inset 0 0 1px grey;

            border-radius: 8px;
          }

          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #41539d;
            border-radius: 8px;
          }

          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #546fd7;
          }

          .item {
            margin: 10px 0px 20px 0px;
            max-height: fit-content;
            display: flex;
            flex-direction: row;
            text-align: center;
            justify-content: space-around;

            .item-right {
            }
            .item-center {
              font-weight: bolder;
            }
            .item-left {
              color: ${variables.$warm_grey};
            }
          }
        }

        .show-more {
          @media (max-width: 990px) {
            display: block;
          }
          text-align: center;
          display: none;
          border-bottom-right-radius: 8px;
          border-bottom-left-radius: 8px;
          position: relative;
          background-image: linear-gradient(
            to bottom,
            rgba(194, 194, 194, 0),
            #a2a2a2
          );
        }
      }
      .left {
        @media (max-width: 990px) {
          width: 100%;
          font-size: 14px;
          margin-bottom: 20px;
        }
        @media (max-width: 590px) {
          font-size: 12px;
        }
        width: 32%;
        height: inherit;

        .items {
          @media (min-width: 990px) {
            min-height: 100% !important;
            overflow-y: scroll;
            ::-webkit-scrollbar {
              width: 8px;
            }

            /* Track */
            ::-webkit-scrollbar-track {
              background-color: rgba(129, 129, 129, 0.1);
              box-shadow: inset 0 0 1px grey;

              border-radius: 8px;
            }

            /* Handle */
            ::-webkit-scrollbar-thumb {
              background: #41539d;
              border-radius: 8px;
            }

            /* Handle on hover */
            ::-webkit-scrollbar-thumb:hover {
              background: #546fd7;
            }
          }
          transition: max-height ease 0.7s;
          -moz-transition: max-height 0.7s; /* Firefox 4 */
          -webkit-transition: max-height 0.7s; /* Safari and Chrome */
          -o-transition: max-height 0.7s;
          display: flex;
          flex-direction: column;
          height: fit-content;
          overflow: hidden;
          text-align: center;
          border-radius: 8px;
          background-color: #f5f6fa;
          /* Track */
          ::-webkit-scrollbar-track {
            background-color: rgba(129, 129, 129, 0.1);
            box-shadow: inset 0 0 1px grey;

            border-radius: 8px;
          }

          /* Handle */
          ::-webkit-scrollbar-thumb {
            background: #41539d;
            border-radius: 8px;
          }

          /* Handle on hover */
          ::-webkit-scrollbar-thumb:hover {
            background: #546fd7;
          }

          .item {
            margin: 10px 0px 20px 0px;
            max-height: fit-content;
            display: flex;
            flex-direction: row;
            text-align: center;
            justify-content: space-around;

            .item-right {
            }
            .item-center {
              font-weight: bolder;
            }
            .item-left {
              color: ${variables.$warm_grey};
            }
          }
        }

        .show-more {
          @media (max-width: 990px) {
            display: block;
          }
          text-align: center;
          display: none;
          border-bottom-right-radius: 8px;
          border-bottom-left-radius: 8px;
          position: relative;
          background-image: linear-gradient(
            to bottom,
            rgba(194, 194, 194, 0),
            #a2a2a2
          );
        }
      }
    }
  }
`;
